export const Config = {
	environment: 'production',
	sentry     : {
		dsn        : 'https://ebd4e227e4f544749dfc99701332ae09@trace.windware.net/4',
		sample_rate: 0.1,
	},
}
